function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#575D7C",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M6.944 0C5.417 0 4.167 1.25 4.167 2.778v5.555c0 1.528 1.25 2.778 2.777 2.778h2.778l2.138 3.206c.304.457.976.457 1.28 0l2.138-3.206h2.778c1.527 0 2.777-1.25 2.777-2.778V2.778C20.833 1.25 19.583 0 18.056 0H6.944zM5.556 15.278c-1.535 0-2.778 1.243-2.778 2.778 0 1.534 1.243 2.777 2.778 2.777 1.534 0 2.777-1.243 2.777-2.777 0-1.535-1.243-2.778-2.777-2.778zm13.888 0c-1.534 0-2.777 1.243-2.777 2.778 0 1.534 1.243 2.777 2.777 2.777 1.535 0 2.778-1.243 2.778-2.777 0-1.535-1.243-2.778-2.778-2.778zM5.556 22.222C2.52 22.222 0 23.484 0 25.302v1.087c0 .767.622 1.389 1.389 1.389h8.333c.767 0 1.39-.622 1.39-1.39v-1.087c0-1.817-2.522-3.079-5.556-3.079zm13.888 0c-3.034 0-5.555 1.262-5.555 3.08v1.087c0 .767.622 1.389 1.389 1.389h8.333c.767 0 1.389-.622 1.389-1.39v-1.087c0-1.817-2.52-3.079-5.556-3.079z",
  transform: "translate(-22 -283) translate(22 283)"
}))));

var SvgParentMembers = function SvgParentMembers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgParentMembers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/parent-members.1a4be7a4.svg";
export { ForwardRef as ReactComponent };